/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SalesContactSimilarEmailOtherCompany
 */
export interface SalesContactSimilarEmailOtherCompany {
  /**
   *
   * @type {string}
   * @memberof SalesContactSimilarEmailOtherCompany
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof SalesContactSimilarEmailOtherCompany
   */
  companyName: string;
  /**
   *
   * @type {string}
   * @memberof SalesContactSimilarEmailOtherCompany
   */
  email: string;
}

/**
 * Check if a given object implements the SalesContactSimilarEmailOtherCompany interface.
 */
export function instanceOfSalesContactSimilarEmailOtherCompany(
  value: object,
): value is SalesContactSimilarEmailOtherCompany {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("companyName" in value) || value["companyName"] === undefined)
    return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  return true;
}

export function SalesContactSimilarEmailOtherCompanyFromJSON(
  json: any,
): SalesContactSimilarEmailOtherCompany {
  return SalesContactSimilarEmailOtherCompanyFromJSONTyped(json, false);
}

export function SalesContactSimilarEmailOtherCompanyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SalesContactSimilarEmailOtherCompany {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    companyName: json["companyName"],
    email: json["email"],
  };
}

export function SalesContactSimilarEmailOtherCompanyToJSON(
  json: any,
): SalesContactSimilarEmailOtherCompany {
  return SalesContactSimilarEmailOtherCompanyToJSONTyped(json, false);
}

export function SalesContactSimilarEmailOtherCompanyToJSONTyped(
  value?: SalesContactSimilarEmailOtherCompany | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    companyName: value["companyName"],
    email: value["email"],
  };
}
